import { useEffect } from 'react';

import { createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import { fetchLists } from 'mastodon/actions/lists';

import ColumnLink from './column_link';
import { ListIcon } from 'mastodon/components/icons/list';

const getOrderedLists = createSelector([state => state.get('lists')], lists => {
  if (!lists) {
    return lists;
  }

  return lists.toList().filter(item => !!item).sort((a, b) => a.get('title').localeCompare(b.get('title'))).take(4);
});

export const ListPanel = ({ closeSidebar }) => {
  const dispatch = useDispatch();
  const lists = useSelector(state => getOrderedLists(state));

  useEffect(() => {
    dispatch(fetchLists());
  }, [dispatch]);

  if (!lists || lists.isEmpty()) {
    return null;
  }

  const ListActiveIcon = () => <ListIcon className='icon-active' />;

  return (
    <div className='list-panel'>
      <hr />

      {lists.map(list => (
        <ColumnLink onClick={closeSidebar} icon='list-ul' key={list.get('id')} iconComponent={ListIcon} activeIconComponent={ListActiveIcon} text={list.get('title')} to={`/lists/${list.get('id')}`} transparent />
      ))}
    </div>
  );
};
